import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as AppClasses from '../Application/styles.module.scss';
import SubscribeToNewsletterFooter from '../subscribe_to_newsletter/subscribe_to_newsletter_footer';
import * as Classes from './styles.module.scss';
import LocaleSelected from '../../../shared/locale_selection/locale_selected';
import TutorialIcon from '../Viewer/tutorial_icon';
import { POPULAR_CATEGORIES } from '../wall_arts/index';

const Footer = ({ allowMailSubscription, disallow }) => {
  const renderCopy = (
    <div className={ Classes.copy }>
      <div>
        <span>
          &copy;
          { window.copyRightYear }
          &nbsp;
          Artfully Walls &reg;
        </span>
        All rights reserved.
      </div>
    </div>
  );

  const subscriptionForm = allowMailSubscription ? (
    <div>
      <div className={ Classes.subscribe }>
        <SubscribeToNewsletterFooter
          allowMailSubscription={ allowMailSubscription }
          disallow={ disallow }
        />
      </div>
      { renderCopy }
    </div>
  ) : renderCopy;

  return (
    <div className={ classnames(AppClasses.container20, Classes.border) }>
      <div className={ AppClasses.innerContainer20 }>
        <div className={ Classes.footer }>
          <ul className={ Classes.menu }>
            <li>
              <h5>
                <div>Artfully Walls</div>
              </h5>
              <a href={ `${ window.currentLocale.basename }/about` }>
                About Us&nbsp;
                <TutorialIcon />
              </a>
              <a href={ `${ window.currentLocale.basename }/contact_us` }>Contact Us</a>
              <a href={ `${ window.currentLocale.basename }/trade_program` }>Trade Program</a>
              <a href="/press">As Seen In Press</a>
              <a href="/artful-insights">Artful Insights</a>
              <a href={ `${ window.currentLocale.basename }/get-promo-code` }>Stay Updated</a>
              <LocaleSelected />
            </li>
            <li>
              <h5>
                <div>Artists Info</div>
              </h5>
              <a href={ `${ window.currentLocale.basename }/sell_with_us` }>Sell with Us</a>
              <a href={ `${ window.currentLocale.basename }/artist_faq` }>Artist FAQs</a>
              <a href={ `${ window.currentLocale.basename }/artist_agreement` }>Artist Agreement</a>
              <a href={ `${ window.currentLocale.basename }/copyright_policy` }>Copyright Policy</a>
            </li>
            <li>
              <h5>
                <div>Shop</div>
              </h5>
              <a href={ `${ window.currentLocale.basename }/art-prints` }>Art Prints and Framed Art Prints</a>
              <a href={ `${ window.currentLocale.basename }/art-prints/medium/canvas` }>Canvas Prints</a>
              <a href={ `${ window.currentLocale.basename }/styles/photography` }>Photography</a>
              <a href={ `${ window.currentLocale.basename }/walls?as=thumb` }>Gallery Walls</a>
              <a href={ `${ window.currentLocale.basename }/wall-art` }>{ POPULAR_CATEGORIES }</a>
              <a href="/popular-search-categories">Popular Searches</a>
              <a href={ `${ window.currentLocale.basename }/designer_picks` }>Designer Picks</a>
              <a href={ `${ window.currentLocale.basename }/gift_cards` }>Gift Cards</a>
            </li>
            <li>
              <h5>
                <div>Help And Info</div>
              </h5>
              <a href={ `${ window.currentLocale.basename }/query_order_status` }>Order Status</a>
              <a href={ `${ window.currentLocale.basename }/shipping_info` }>Shipping Info</a>
              <a href={ `${ window.currentLocale.basename }/return_policy` }>Return Policy</a>
              <a href={ `${ window.currentLocale.basename }/terms_of_use` }>Terms Of Use</a>
              <a href={ `${ window.currentLocale.basename }/privacy` }>Privacy Policy</a>
              <a href={ `${ window.currentLocale.basename }/privacy#ccpa` }>Do Not Sell My Info</a>
              <a href={ `${ window.currentLocale.basename }/customer_faq` }>Customer FAQs</a>
            </li>
            <li className={ Classes.share }>
              <h5>Share And Follow</h5>
              <a href="https://www.instagram.com/artfullywalls/" rel="noopener noreferrer" target="_blank">
                <svg
                  width={ 32 }
                  height={ 32 }
                  shapeRendering="geometricPrecision"
                  textRendering="geometricPrecision"
                  imageRendering="optimizeQuality"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  viewBox="0 0 640 640"
                >
                  <path d="M184.715 2.752h270.582C556.908 2.752 640 84.816 640 185.069v269.85c0 100.277-83.092 182.317-184.703 182.317H184.715C83.104 637.236 0 555.196 0 454.919v-269.85C0 84.816 83.103 2.752 184.715 2.752zm133.561 145.939c98.741 0 178.868 80.127 178.868 178.868 0 98.753-80.127 178.868-178.868 178.868-98.765 0-178.88-80.115-178.88-178.868 0-98.741 80.115-178.868 178.88-178.868zm0 60.414c65.387 0 118.454 53.056 118.454 118.454s-53.068 118.466-118.454 118.466c-65.41 0-118.466-53.067-118.466-118.466 0-65.398 53.056-118.454 118.466-118.454zM491.321 123.9c16.04 0 29.044 13.004 29.044 29.032 0 16.04-13.004 29.044-29.044 29.044-16.028 0-29.032-13.004-29.032-29.044 0-16.028 13.004-29.032 29.032-29.032zM206.825 54.58H433.21c85.005 0 154.526 69.178 154.526 153.712V435.81c0 84.532-69.52 153.699-154.526 153.699H206.825c-85.005 0-154.537-69.167-154.537-153.7V208.29c0-84.532 69.532-153.71 154.537-153.71z" />
                </svg>
                <span>Instagram</span>
              </a>
              <a href="http://www.facebook.com/ArtfullyWalls" rel="noopener noreferrer" target="_blank">
                <svg
                  width={ 32 }
                  height={ 32 }
                  shapeRendering="geometricPrecision"
                  textRendering="geometricPrecision"
                  imageRendering="optimizeQuality"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  viewBox="0 0 640 640"
                >
                  <path d="M380.001 120.001h99.993V0h-99.993c-77.186 0-139.986 62.8-139.986 139.986v60h-80.009V320h79.985v320h120.013V320h99.994l19.996-120.013h-119.99v-60.001c0-10.843 9.154-19.996 19.996-19.996v.012z" />
                </svg>
                <span>Facebook</span>
              </a>
              <a href="https://pinterest.com/artfullywalls/" rel="noopener noreferrer" target="_blank">
                <svg
                  viewBox="0 0 2599 3333"
                  shapeRendering="geometricPrecision"
                  textRendering="geometricPrecision"
                  imageRendering="optimizeQuality"
                  fillRule="evenodd"
                  clipRule="evenodd"
                >
                  <path d="M576 3333c185-165 312-400 374-641 25-95 127-484 127-484 66 127 261 234 466 234 614 0 1056-564 1056-1267C2599 502 2050-1 1344-1 465-1-1 589-1 1231c0 298 159 670 413 788 38 19 59 10 68-28 6-29 41-166 57-231 5-20 3-39-14-59-84-102-152-290-152-464 0-449 340-884 919-884 500 0 850 340 850 828 0 551-278 933-640 933-200 0-350-165-301-368 58-242 169-503 169-677 0-156-83-286-258-286-205 0-368 211-368 495 0 180 60 302 60 302s-202 853-239 1012c-41 176-25 423-7 584l18 158z" />
                </svg>
                <span>Pinterest</span>
              </a>
              <a href={ `${ window.currentLocale.basename }/my/referral` }>
                <svg viewBox="0 0 82 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M43.4671 21.0882C49.5153 20.47 56.6657 19.1636 61.8191 16.978C64.9856 15.6351 66.9856 14.1289 67.7829 12.6248C68.1484 11.9352 68.2785 11.2179 68.1314 10.3979C67.9777 9.54125 67.4984 8.45633 66.4382 7.13116C64.3725 4.54894 62.3675 3.85971 60.4987 4.02265C58.461 4.20031 56.1556 5.42676 53.7218 7.57019C49.7905 11.0325 46.1135 16.3605 43.4671 21.0882ZM60.1513 0.0377671C63.5991 -0.262836 66.8275 1.2146 69.5617 4.63238C70.9016 6.30721 71.7639 7.99312 72.0686 9.69177C72.3798 11.4272 72.0849 13.0497 71.3171 14.4982C70.8052 15.4637 70.0955 16.3311 69.2456 17.1119L80.7918 22.1634L80.8016 22.1677C80.8816 22.2027 80.9585 22.2425 81.032 22.2868C81.1356 22.3491 81.2324 22.4202 81.3217 22.4989C81.7367 22.8643 81.9889 23.3925 81.9996 23.9622C81.9999 23.9748 82 23.9874 82 24V70.3622C82 71.1479 81.54 71.8608 80.8241 72.1845L41.8343 89.8177C41.7682 89.8481 41.7008 89.8746 41.6324 89.8974C41.1604 90.0547 40.6401 90.0322 40.1759 89.8223L40.1657 89.8177L1.17586 72.1845C0.46 71.8608 0 71.1479 0 70.3622V24L3.33721e-06 23.9963C0.000633359 23.6504 0.0904481 23.3185 0.252135 23.0279C0.317164 22.911 0.393818 22.8008 0.480971 22.699C0.635463 22.5185 0.822947 22.3646 1.03715 22.247C1.05699 22.2361 1.07705 22.2255 1.09734 22.2153C1.12214 22.2027 1.14714 22.1907 1.17234 22.1793L11.3682 17.4838C10.3299 16.609 9.46831 15.6198 8.87373 14.4982C8.10594 13.0497 7.81096 11.4272 8.12223 9.69177C8.4269 7.99312 9.28921 6.30721 10.6291 4.63238C13.3633 1.2146 16.5917 -0.262836 20.0395 0.0377671C23.3185 0.323647 26.4131 2.19095 29.1126 4.56835C30.2235 5.54664 31.3057 6.64559 32.3478 7.82212L39.1634 4.68338C39.6822 4.44446 40.2784 4.43875 40.8016 4.66768L47.8902 7.76891C48.9177 6.61245 49.9841 5.53188 51.0782 4.56835C53.7777 2.19095 56.8723 0.323647 60.1513 0.0377671ZM34.9567 11.0244C36.907 13.6114 38.6519 16.3633 40.0954 18.9233C41.5461 16.3505 43.3012 13.5839 45.2633 10.9857L40.021 8.69221L34.9567 11.0244ZM32.5075 24.6052C27.1526 23.8517 21.3582 22.5895 16.8099 20.6605C16.3368 20.4599 15.869 20.2487 15.4102 20.0261L6.87455 23.957L20.4245 29.9099L32.5075 24.6052ZM63.3809 20.6605C64.0396 20.3811 64.6882 20.0813 65.3163 19.7589L74.9494 23.9734L60.9662 29.9162L47.9063 24.5735C53.1986 23.8166 58.8957 22.5627 63.3809 20.6605ZM21.5 34.9147L39 42.7436V84.9005L21.5 76.9861V34.9147ZM4 27.0857L17.5 33.1252V75.1771L4 69.0717V27.0857ZM55.7848 32.1183L40.3666 38.6711L25.398 32.0949L40.0276 25.6722L55.7848 32.1183ZM60 77.2122L43 84.9005V42.4397L60 34.9711V77.2122ZM64 33.2138V75.4032L78 69.0717V27.0632L64 33.2138ZM18.3717 16.978C23.525 19.1636 30.6755 20.47 36.7237 21.0882C34.0773 16.3605 30.4003 11.0325 26.469 7.57019C24.0352 5.42676 21.7298 4.20031 19.6921 4.02265C17.8233 3.85971 15.8183 4.54894 13.7526 7.13116C12.6924 8.45633 12.2131 9.54125 12.0594 10.3979C11.9123 11.2179 12.0424 11.9352 12.4079 12.6248C13.2052 14.1289 15.2052 15.6351 18.3717 16.978Z" fill="black" />
                </svg>
                <span>Give &amp; Get</span>
              </a>
            </li>
          </ul>
          { subscriptionForm}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  allowMailSubscription: PropTypes.bool.isRequired,
  disallow: PropTypes.func.isRequired
};

export default Footer;
